export const pushIfNotExistsAndNotNull = <T>(array: T[], value: T, key?: keyof T) => {
  if (key) {
    const found = array.some(currentValue => currentValue[key] === value[key]);

    if (!found) {
      array.push(value);
    }
  } else if (!array.includes(value) && !!value) {
    array.push(value);
  }
};
